<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{year}}
      <a href="https://www.solidtectecnologia.com.br">Solidtec Tecnologia</a></strong>
      <span v-if="flag === 'es'">. Todos los derechos reservados.</span>
      <span v-else-if="flag === 'de'">. Alle rechte vorbehalten.</span>
      <span v-else-if="flag === 'us'">. All rights reserved.</span>
      <span v-else>. Todos os direitos reservados.</span>
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  computed: {
    flag () {
      return this.$store.state.flag
    }
  },
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?2e8e24f2